import React from "react";
import { useFilterContext } from "../context/filter_context";
import GridView from "./GridView";

const ProductList = () => {
  const { filtered_products: products } = useFilterContext();

  if (products.length < 1) {
    return (
      <h5 style={{ textTransform: "none" }}>
        Omlouváme se, ale žádný produkt nebyl nalezen...
      </h5>
    );
  }

  // Always show tents first
  const tents = [];
  const rest = [];
  for (const p of products) {
    if (p?.category === "party stany") {
      tents.push(p);
    } else {
      rest.push(p);
    }
  }
  const ordered = [...tents, ...rest];

  return <GridView products={ordered} />;
};

export default ProductList;
